var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 1.2C9.8 0.537259 10.3373 0 11 0C11.6627 0 12.2 0.537258 12.2 1.2V2.4H21.8V1.2C21.8 0.537259 22.3373 0 23 0C23.6627 0 24.2 0.537258 24.2 1.2V2.4H25.4C27.3882 2.4 29 4.01178 29 6V20.4C29 22.3882 27.3882 24 25.4 24H12C12 23.4916 11.8073 22.9832 11.422 22.5936L7.96047 19.0936C7.18375 18.3083 5.91743 18.3013 5.13208 19.078C5.08529 19.1243 5.04126 19.1723 5 19.2218V6C5 4.01178 6.61178 2.4 8.6 2.4H9.8V1.2ZM14.6 12C13.9373 12 13.4 12.5373 13.4 13.2C13.4 13.8627 13.9373 14.4 14.6 14.4H23C23.6627 14.4 24.2 13.8627 24.2 13.2C24.2 12.5373 23.6627 12 23 12H14.6ZM11 16.8C10.3373 16.8 9.8 17.3373 9.8 18C9.8 18.6627 10.3373 19.2 11 19.2H18.2C18.8627 19.2 19.4 18.6627 19.4 18C19.4 17.3373 18.8627 16.8 18.2 16.8H11Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24H10M10 24L6.53846 20.5M10 24L6.53846 27.5",
    stroke: "#777E91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInCalendar);
export default __webpack_public_path__ + "static/media/check-in-calendar.b3b9300da734a74cd6130bf13980a814.svg";
export { ForwardRef as ReactComponent };